module.exports = __webpack_public_path__ + "img/igluglow.97e1a15a.jpg";